import { InputText, TextArea } from "@bluframe/blublocks"
import CriticsOverrides from "components/Critics/PodSource/Overrides"

import { ComponentProps } from "."

const Overrides = ({
  onNameChange,
  onTextChange,
  overrides
}: ComponentProps) => (
  <CriticsOverrides>
    <InputText
      inputId="name"
      label="Name"
      name="name"
      onChange={onNameChange}
      value={overrides.name ?? ""}
    />

    <TextArea
      inputId="text"
      label="Text"
      name="text"
      onChange={onTextChange}
      value={overrides.text ?? ""}
    />
  </CriticsOverrides>
)
export default Overrides
